<script>
import Tabs from '../Tabs.vue'
import Tab from '../Tab.vue'
import LoadingCvPersonalDetails from './Applicant/LoadingCV/PersonalDetails.vue'
import KillerQuestions from './Applicant/KillerQuestions.vue'
import LoadingCvAims from './Applicant/LoadingCV/Aims.vue'
import Accordion from '../Accordion.vue'
import AccordionItem from '../AccordionItem.vue'
import LanguageProficiency from './Applicant/LanguageProficiency.vue'
import SkillAssessment from './Applicant/SkillAssessment.vue'
import TelephonicScreening from './Applicant/TelephonicScreening.vue'
import FirstInterview from './Applicant/FirstInterview.vue'
import PanelInterview from './Applicant/PanelInterview.vue'
import BackgroundVerification from './Applicant/BackgroundVerification.vue'
import Onboarding from './Applicant/Onboarding.vue'
import Start from './Applicant/Start.vue'
import LoadingOffer from './Applicant/LoadingOffer.vue'
import Cv from './Applicant/LoadingCV/Cv.vue'
import QuickMessageModal from './Applicant/QuickMessageModal.vue'
import RecruiterNotesModal from './Applicant/RecruiterNotesModal.vue'
import ExportStageModal from './Applicant/ExportStageModal.vue'
import CandidateOverviewModal from './Applicant/CandidateOverviewModal.vue'
import ApplicantsSidebar from './ApplicantsSidebar.vue'
export default {
    components: {
        Tabs,
        Tab,
        LoadingCvPersonalDetails,
        KillerQuestions,
        LanguageProficiency,
        Accordion,
        AccordionItem,
        LoadingCvAims,
        SkillAssessment,
        TelephonicScreening,
        FirstInterview,
        PanelInterview,
        BackgroundVerification,
        LoadingOffer,
        Onboarding,
        Start,
        Cv,
        QuickMessageModal,
        RecruiterNotesModal,
        ExportStageModal,
        CandidateOverviewModal,
        ApplicantsSidebar
    },

    data() {
        return {
            hasMatric: false,
            backgroundVerificationFailCount: 0,
            unavailableCount: 0,
            notShowingUpCount: 0,
            previousRejectionsCount: 0,
            recycleCount: 0,
            atsType: this.jobApplication.job.requisition.person_specification.ats_type,
            currentTab: ''
        }
    },

    mounted() {
        if (this.jobApplication.user.user_detail !== null) {
            this.jobApplication.user.user_detail.qualifications.forEach(qualification => {
                if (qualification.matric_certificate_number) {
                    this.hasMatric = true;
                    return;
                }
            });
        }
        if (this.jobApplication.job_application_actions !== null) {
            this.jobApplication.job_application_actions.forEach(action => {
                if (action.step === 'background_verification' && action.action === 'failed') {
                    this.backgroundVerificationFailCount++;
                }
                if (action.step === 'telephonic_screening' || action.step === 'first_interview' || action.step === 'panel_interview') {
                    if (action.action === 'failed') {
                        this.unavailableCount++;
                    }
                }
                if (action.step === 'onboarding' || action.step === 'start') {
                    if (action.action === 'failed') {
                        this.notShowingUpCount++;
                    }
                }
                if (action.action === 'failed') {
                    this.previousRejectionsCount++;
                }
                if (action.action === 'recycled') {
                    this.recycleCount++;
                }
            });
        }
        this.currentTab = window.location.hash.replace('#', '');
    },

    props: {
        jobApplication: {
            type: Object|Array,
            required: true
        },
        module: {
            type: Object|Array,
            required: true
        },
        traitStatementsByCluster: {
            type: Array,
            required: true
        },
        csrfToken: {
            type: String,
            required: true
        },
        interviewAnswers: {
            type: Object|Array,
            required: true
        },
        interviewScores: {
            type: Object|Array,
            required: true
        },
        applicationPhaseLogs: {
            type: Object|Array,
            required: false
        },
        sageLog: {
            type: Object|Array,
            required: false
        },
        failedJobApplications: {
            type: Object|Array,
            required: false
        },
        ifactFormEverConvicted: {
            type: Object|Array,
            required: false
        },
        idVerificationCheck: {
            type: Object|Array,
            required: false
        }
    },
    methods: {
        toggleModal(ref) {
            this.$refs[ref].toggleModal()
        },
        sendToSage(event) {
			if (confirm(`Are you sure you want send to sage with external requisition number ${this.jobApplication.job.requisition.job_profile.external_requisition_number}?`)) {
                window.location.href = `/recruiter/active-requisitions/send-to-sage/${this.jobApplication.id}`;
			}
		},
        applicantChanged(data){
            this.jobApplication = data.jobApplication;
            this.module = data.module;
            this.traitStatementsByCluster = data.traitStatementsByCluster;
            this.failedJobApplications = data.failedJobApplications;
            this.ifactFormEverConvicted = data.ifactFormEverConvicted;
            this.interviewAnswers = data.interviewAnswers;
            this.interviewScores = data.interviewScores;
            this.applicationPhaseLogs = data.applicationPhaseLogs;
            this.sageLog = data.sageLog;

            window.history.replaceState({}, '', `/recruiter/active-requisitions/applicant/${this.jobApplication.id}#${this.jobApplication.current_application_phase}`);
        },

        phaseChanged(data) {
            this.currentTab = data;
        }
    }
}
</script>

<style>
.recycle {
    background-color: #979798;
}
</style>

<template>
    <div class="requisitions-applicant grid-x grid-padding-x grid-padding-y">
        <div class="cell small-2">
            <applicants-sidebar
                :csrfToken="csrfToken"
                :requisition="jobApplication.job.requisition"
                @applicant-loaded="applicantChanged"
                :default-applicant="jobApplication"
                @phase-changed="phaseChanged"
            >
            </applicants-sidebar>
        </div>
        <div class="cell small-10">
            <div class="flex">
                <span class="p-2">
                    <strong>{{ jobApplication.user.full_name }}</strong>
                    <p v-if="jobApplication.user">
                        <span v-if="jobApplication.user.country_id === 246">ID Number: {{ jobApplication.user.id_number }}</span>
                        <span v-else>Passport Number: {{ jobApplication.user.passport_number }}</span>
                    </p>
                    <p v-if="jobApplication.job.requisition.job_profile.external_requisition_number">External Req #: <i style="color:red">{{ jobApplication.job.requisition.job_profile.external_requisition_number }}</i></p>
                    <p v-if="jobApplication.job.requisition.job_profile.sage_job_requisition">
                        Sage Job Req:
                        <i style="color:red">{{ jobApplication.job.requisition.job_profile.sage_job_requisition.job_title}}</i>
                    </p>
                </span>
                <div class="p-2 documents icon black middle">
                    <i class="fa-solid fa-user-shield"
                    :title="'Background Verification: ' + backgroundVerificationFailCount">
                    </i>
                    <span v-if="backgroundVerificationFailCount > 0"
                        class="notification-count">
                        {{ backgroundVerificationFailCount }}
                    </span>
                </div>
                <div class="p-2 documents icon black">
                    <i class="fa-solid fa-phone-slash"
                    :title="'Unavailable: ' + unavailableCount">
                    </i>
                    <span v-if="unavailableCount > 0"
                        class="notification-count">
                        {{ unavailableCount }}
                    </span>
                </div>
                <div class="p-2 documents icon black">
                    <i class="fa-solid fa-user-xmark"
                    :title="'Not Showing Up: ' + notShowingUpCount">
                    </i>
                    <span v-if="notShowingUpCount > 0"
                        class="notification-count">
                        {{ notShowingUpCount }}
                    </span>
                </div>
                <div class="p-2 documents icon black">
                    <i class="fa-solid fa-circle-exclamation"
                    :title="'Previous Rejections: ' + previousRejectionsCount">
                    </i>
                    <span v-if="previousRejectionsCount > 0"
                        class="notification-count">
                        {{ previousRejectionsCount }}
                    </span>
                </div>
                <div class="p-2 documents icon black">
                    <i class="fa-solid fa-recycle"
                    :title="'Recycles: ' + recycleCount">
                    </i>
                    <span v-if="recycleCount > 0"
                        class="notification-count">
                        {{ recycleCount }}
                    </span>
                </div>
                <div v-if="jobApplication.user.baseline_score" class="p-2 documents icon black">
                    <i class="fa-solid fa-award"
                    :title="'Baseline Score: ' + jobApplication.user.baseline_score">
                    </i>
                </div>
                <div v-if="jobApplication.user.id_path"
                     class="p-2 documents icon">
                    <i class="fa-regular fa-id-card" title="ID Document"></i>
                </div>
                <div v-if="hasMatric"
                     class="p-2 documents icon">
                    <i class="fa-solid fa-graduation-cap" title="Matric Qualification"></i>
                </div>
                <div v-if="jobApplication.user.user_detail !== null && jobApplication.user.user_detail.user_detail_jobs"
                    class="p-2 documents icon">
                    <i class="fa-solid fa-briefcase" title="Work Experience"></i>
                </div>
                <div v-if="ifactFormEverConvicted && ifactFormEverConvicted.is_ever_convicted"
                    class="p-2 documents icon text-danger">
                    <i class="fa-solid fa-flag" :title="ifactFormEverConvicted.document_url ? 'Candidate information could not be retrieved, please view iFacts form for more conviction info' : ifactFormEverConvicted.conviction_details"></i>
                </div>
                <div class="padding-left">
                    <a class="btn btn-success mycalling-green documents" :href="`/recruiter/ifacts/index?application_id=${jobApplication.id}`">Ifacts</a>
                    <a class="btn btn-success mycalling-green documents" :href="`${jobApplication.user.cv_url}`" download>Download CV</a>
                    <a @click="toggleModal('candidateOverviewModal')" class="btn btn-success mycalling-green documents">Candidate Overview</a>
                    <a @click="toggleModal('quickMessageModal')" class="btn btn-success mycalling-green documents">Quick Message</a>
                    <a @click="toggleModal('exportStageModal')" class="btn btn-success mycalling-green documents">Export Stages</a>
                    <a class="btn btn-success mycalling-green documents" :href="`/recruiter/user-documents/index/${jobApplication.user_id}?aplication_id=${jobApplication.id}`">Additional documents</a>
                    <a @click="toggleModal('recruiterNotesModal')" class="btn btn-success mycalling-green documents">Recruiter Notes</a>
                    <a class="btn btn-success mycalling-green documents" :href="`/recruiter/active-requisitions/impersonate/${jobApplication.id}`">Impersonate/Edit</a>

                    <a v-if="(jobApplication.application_phase == 'start' || jobApplication.application_phase == 'loading_offer') && jobApplication.job.requisition.job_profile.external_requisition_number && jobApplication.job.requisition.job_profile.sage_job_requisition_id" class="btn btn-success mycalling-green documents" @click="sendToSage">Send to Sage</a>
                    <a v-else disabled style="pointer-events:all; background-color: #CCCCCC; border-color: #CCCCCC;" title="You can not Send to Sage, please check that there is the correct External Req # and Sage Req ID linked to this candidate application, and that they are in Start or Loading Offer before trying again." class="btn btn-primary mycalling-green documents disabled">Send to Sage</a>
                </div>
            </div>
            <tabs :selected="`#${currentTab}`">
                <tab name="Loading CV" class="p-4" override-href="loading_cv">
                    <Cv
                        :csrfToken="csrfToken"
                        :jobApplication="jobApplication"
                        :module="module"
                        :trait-statements-by-cluster="traitStatementsByCluster"
                        :failedJobApplications="failedJobApplications"
                    />
                </tab>

                <tab name="Killer Questions" class="p-2" override-href="killer_questions">
                    <KillerQuestions
                        :job-application="jobApplication"
                        :csrf-token="csrfToken"
                        :logs="applicationPhaseLogs.killer_questions"
                    />
                </tab>

                <tab v-if="atsType != 'leadership_and_support'" name="Voice Assessment" class="p-2" override-href="language_proficiency">
                    <LanguageProficiency
                        :job-application="jobApplication"
                        :csrf-token="csrfToken"
                        :logs="applicationPhaseLogs.language_proficiency"
                    />
                </tab>

                <tab :name="atsType == 'leadership_and_support' ? 'Telephonic CV screening' : 'Telephonic screening'" override-href="telephonic_screening">
                    <TelephonicScreening
                        :job-application="jobApplication"
                        :csrf-token="csrfToken"
                        :module="module"
                        :trait-statements-by-cluster="traitStatementsByCluster"
                        :interview-answers="interviewAnswers"
                        :interview-scores="interviewScores"
                        :logs="applicationPhaseLogs.telephonic_screening"
                        :id-verification-check="idVerificationCheck"
                    />
                </tab>

                <tab name="1st Interview" override-href="first_interview">
                    <FirstInterview
                        :job-application="jobApplication"
                        :csrf-token="csrfToken"
                        :module="module"
                        :trait-statements-by-cluster="traitStatementsByCluster"
                        :interview-answers="interviewAnswers"
                        :interview-scores="interviewScores"
                        :logs="applicationPhaseLogs.first_interview"
                    />
                </tab>

                <tab v-if="atsType == 'leadership_and_support'" name="Background Verification" class="p-2" override-href="background_verification">
                    <BackgroundVerification
                     :job-application="jobApplication"
                     :csrf-token="csrfToken"
                     :logs="applicationPhaseLogs.background_verification"
                     :ats-type="atsType"
                     :panel-interview-logs="applicationPhaseLogs.panel_interview"
                     />
                </tab>

                <tab :name="atsType == 'leadership_and_support' ? 'Psychometric Assessment' : 'Skill Assessment'" class="p-2" override-href="skills_assessment">
                    <SkillAssessment
                        :job-application="jobApplication"
                        :csrf-token="csrfToken"
                        :logs="applicationPhaseLogs.skills_assessment"
                    />
                </tab>

                <tab name="Panel Interview" override-href="panel_interview">
                    <PanelInterview :job-application="jobApplication" :csrf-token="csrfToken" :module="module"
                        :trait-statements-by-cluster="traitStatementsByCluster"
                        :interview-answers="interviewAnswers"
                        :interview-scores="interviewScores"
                        :logs="applicationPhaseLogs.panel_interview"
                    />
                </tab>

                <tab v-if="atsType != 'leadership_and_support'" name="Background Verification" class="p-2" override-href="background_verification">
                    <BackgroundVerification
                     :job-application="jobApplication"
                     :csrf-token="csrfToken"
                     :logs="applicationPhaseLogs.background_verification"
                     :ats-type="atsType"
                     :panel-interview-logs="applicationPhaseLogs.panel_interview"
                     />
                </tab>

                <tab v-if="!jobApplication.job.requisition.is_pipeline" name="Loading Offer" override-href="loading_offer">
                    <LoadingOffer
                        :job-application="jobApplication"
                        :csrf-token="csrfToken"
                        :logs="applicationPhaseLogs.loading_offer"
                        :sage-log="sageLog"
                    />
                </tab>

                <tab v-if="!jobApplication.job.requisition.is_pipeline" name="Onboarding" override-href="onboarding">
                    <Onboarding
                        :job-application="jobApplication"
                        :csrf-token="csrfToken"
                        :logs="applicationPhaseLogs.onboarding"
                        :sage-log="sageLog"
                        :enable-send-to-sage="(jobApplication.job.requisition.job_profile.external_requisition_number && jobApplication.job.requisition.job_profile.sage_job_requisition_id && jobApplication.job.requisition.job_profile.external_requisition_number !== '' && jobApplication.job.requisition.job_profile.sage_job_requisition_id !== '') ? true : false"

                    />
                </tab>

                <tab v-if="!jobApplication.job.requisition.is_pipeline" name="Start" override-href="start">
                    <Start
                        :job-application="jobApplication"
                        :csrf-token="csrfToken"
                        :logs="applicationPhaseLogs.start"
                        :sage-log="sageLog"
                    />
                </tab>
            </tabs>

            <quick-message-modal ref="quickMessageModal" :job-application="jobApplication" :csrf-token="csrfToken" />
            <recruiter-notes-modal ref="recruiterNotesModal" :job-application="jobApplication" :csrf-token="csrfToken" />
            <export-stage-modal ref="exportStageModal" :job-application="jobApplication" :csrf-token="csrfToken" />
            <candidate-overview-modal ref="candidateOverviewModal" :job-application="jobApplication" :csrf-token="csrfToken" />
        </div>
    </div>
</template>

<style lang="scss">
@import './assets/scss/frontend/base/colour_vars.scss';

.mycalling-green {
    margin-left: auto;
    height: 33px;
}

.documents {
    margin-top: 9px;
}
.icon {
    display: inline-block;
    position: relative;
    padding: 1px;
    padding-right: 2px;
    color: $mycalling-green;
    font-size: 16.44px;
    letter-spacing: 0;
    line-height: 16px;
}

.black {
    color: #455666;
}

.notification-count {
    font-size: 11px;
    color: #fff;
    background-color: #f00;
    padding: 0 4px;
    border-radius: 50%;
    position: absolute;
    top: -4px;
    right: -2px;
}

.padding-left {
    margin-left: auto;
}

.form-control {
    border: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 5px !important;

    label {
        color: #455666;
    }
}

input {
        background: transparent !important;
        border-radius: 5px !important;
        border: 1px solid #D1D1D1 !important;
        margin-bottom: 0 !important;
        height: 40px !important;
        opacity: 1 !important;
}

textarea {
    background: transparent !important;
    border-radius: 5px !important;
    border: 1px solid #D1D1D1 !important;
    margin-bottom: 0 !important;
    height: 40px !important;
    opacity: 1 !important;
}

button {
    text-transform: uppercase !important;
    padding: 7px 17px !important;
    font-size: .9rem !important;
}

p {
    font-weight: normal !important;
}

.yes-no-item {
    input[type='radio']{
        border:3px solid white !important;
        box-shadow:0 0 0 1px $mycalling-green;
        appearance:none;
        border-radius:50% !important;
        width: 20px;
        height: 20px !important;
        background-color:#fff;
        transition:all ease-in 0.2s;
    }

    input[type='radio']:checked{
        background-color:$mycalling-green !important;
    }
}

label {
    font-weight: bold;
}
</style>